/* TÖSTI: finder om tekst-siden står til venstre eller højre for billedet pr. ambassadør-blok, så fadingen kommer fra rette side og i rette farve (brun eller sand alt efter tekstblokkens baggrund). Kører kun på ambassadør-siden.
   Bygger også selv srcset ud fra data-src ({width}-skabelon) + data-widths med det samme ved page load, i stedet for at vente på at lazysizes gør det når billedet nærmer sig viewport — så man aldrig ser theme'ts pladsholder-ikon før man scroller til blokken. Skriver KUN til srcset/sizes, aldrig til src (den skal blive ved med at være pladsholderen, ellers virker responsive-billede-valget ikke). */
(function(){
  'use strict';
  function run(){
    if(!document.body.classList.contains('page-ambassadoerer')) return;
    var blocks = document.querySelectorAll('.featured-content .grid');
    blocks.forEach(function(g){
      var img = g.querySelector('.homepage-image-with-text--image');
      var text = g.querySelector('.homepage-image-with-text--text');
      if(!img || !text) return;
      var ir = img.getBoundingClientRect(), tr = text.getBoundingClientRect();
      img.classList.remove('tosti-fade-left', 'tosti-fade-right');
      img.classList.toggle('tosti-fade-white', !g.classList.contains('tosti-brown-block'));
      if(Math.abs(ir.left - tr.left) < 2 && Math.abs(ir.top - tr.top) >= 0 && ir.top !== tr.top){
        return;
      }
      if(tr.left < ir.left){
        img.classList.add('tosti-fade-left');
      } else {
        img.classList.add('tosti-fade-right');
      }
    });
  }
  function forceEagerImages(){
    if(!document.body.classList.contains('page-ambassadoerer')) return;
    try {
      var imgs = document.querySelectorAll('.featured-content .grid img');
      imgs.forEach(function(im){
        if(im.__tostiForced) return;
        var existingSrcset = im.getAttribute('srcset') || im.getAttribute('data-srcset');
        if(existingSrcset && existingSrcset.indexOf('{width}') === -1 && existingSrcset.length > 0){
          im.setAttribute('srcset', existingSrcset);
          im.classList.remove('lazyload', 'lazyloading');
          im.classList.add('lazyloaded');
          im.__tostiForced = true;
          return;
        }
        var template = im.getAttribute('data-src');
        var widthsRaw = im.getAttribute('data-widths');
        if(!template || template.indexOf('{width}') === -1 || !widthsRaw) return;
        var widths;
        try { widths = JSON.parse(widthsRaw); } catch(e){ return; }
        if(!widths || !widths.length) return;
        var srcset = widths.map(function(w){ return template.replace('{width}', w) + ' ' + w + 'w'; }).join(', ');
        im.setAttribute('srcset', srcset);
        var rectW = Math.ceil(im.getBoundingClientRect().width);
        if(rectW > 0){ im.setAttribute('sizes', rectW + 'px'); }
        im.classList.remove('lazyload', 'lazyloading');
        im.classList.add('lazyloaded');
        im.__tostiForced = true;
      });
    } catch(e){}
  }
  var n = 0, iv = setInterval(function(){ run(); forceEagerImages(); if(++n > 60) clearInterval(iv); }, 200);
  document.addEventListener('DOMContentLoaded', function(){ run(); forceEagerImages(); });
  window.addEventListener('load', function(){ run(); forceEagerImages(); });
  window.addEventListener('resize', run);
})();
